(() => {
  'use strict';
  const box=document.querySelector('[data-tm-wish-context]');
  if(!box)return;
  const query=new URLSearchParams(location.hash.slice(1)).get('parfum');
  if(!query || query.trim().length<3)return;
  const wish=query.trim().slice(0,160);
  box.querySelector('[data-tm-wish-name]').textContent=wish;box.hidden=false;
  // Progressive enhancement: the visible reference remains if Forms changes its markup.
  let tries=0;
  function prefill(){
    const input=document.querySelector('[data-forms-id="forms-root-1179935"] shopify-forms-embed')?.shadowRoot?.getElementById('custom#parfum_et_marque_recherchs');
    if(input){
      if(!input.value){
        Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(input,wish);
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      return;
    }
    if(++tries<40)setTimeout(prefill,250);
  }
  prefill();
})();
